module.exports = __webpack_public_path__ + "img/icon_Messenger.b7484b01.svg";